// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"13603b08","255":"dee661be","567":"99441cd2","858":"38d59623","948":"cfb7c68d","969":"0ad89c9a"}[chunkId] + ".chunk.css";
};